import React from 'react';
import Buttons from '../Buttons/Buttons.tsx';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';
import SecondaryButton from '../Buttons/SecondaryButton.tsx';
import FitAssistantStep from '../../Enums/FitAssistantStep.ts';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import { setShowFitAssistant, setStepEnum } from '../../Slices/FitAssistantSlice.ts';
import {
  CarInformationSelector,
  CurrentStepContentSelector,
  CurrentStepSelector,
  InitialDataSelector,
  TranslationsSelector,
} from '../../Selectors/FitAssistantSelectors';
import { trackOpenEmpty } from '../../Analytics/Adobe.ts';

const VehicleInfoNeeded = () => {
  const dispatch = useAppDispatch();
  const initialData = useAppSelector(InitialDataSelector);
  const currentStepData = useAppSelector(CurrentStepContentSelector);
  const translations = useAppSelector(TranslationsSelector);
  const carInformation = useAppSelector(CarInformationSelector);
  const currentStep = useAppSelector(CurrentStepSelector);

  return (
    <>
      <div
        className="variation-selector d-flex flex-column justify-content-center"
        dangerouslySetInnerHTML={{
          __html: currentStepData?.Text ?? '',
        }}
      ></div>
      <Buttons visible>
        <PrimaryButton
          visible
          text={translations.confirmVehicleFit}
          onClick={() => {
            dispatch(initialData.IsYearFirst ? setStepEnum(FitAssistantStep.Year) : setStepEnum(FitAssistantStep.Make));
            trackOpenEmpty(initialData.FitAssistantVariation, initialData.IsYearFirst, carInformation, currentStep);
          }}
        />
        <SecondaryButton visible text={translations.close} onClick={() => dispatch(setShowFitAssistant(false))} />
      </Buttons>
    </>
  );
};

export default VehicleInfoNeeded;
